"use strict";

exports.__esModule = true;
exports.default = void 0;

var _utils = require("@material-ui/core/utils");

var _jsxRuntime = require("react/jsx-runtime");

var _default = (0, _utils.createSvgIcon)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M19.476 12.773H4.523a.773.773 0 1 1 0-1.546h14.953a.773.773 0 1 1 0 1.546z"
}), 'Minus');

exports.default = _default;